// Raw Material Getters

export const getFullRawMaterialsList = state => {
  return state.fullRawMaterialsList
}

export const getRawMaterialsList = state => {
  return state.rawMaterialsList
}

export const getRawMaterialInfo = state => {
  return state.rawMaterialInfo
}
